import { SATQuestion } from '../../algebra-practice/data/algebraQuestions';

export const geometryTrigQuestions: SATQuestion[] = [
  {
    id: 1,
    subtopic: "Area & Perimeter",
    question: "A rectangle has a length of 14 cm and a width of 9 cm. What is the area of the rectangle?",
    options: [
      { label: "A", value: "46 cm²" },
      { label: "B", value: "92 cm²" },
      { label: "C", value: "126 cm²" },
      { label: "D", value: "144 cm²" }
    ],
    correctAnswer: "C",
    solution: {
      steps: [
        "Area of a rectangle = length × width",
        "Area = 14 × 9",
        "Area = 126 cm²"
      ],
      explanation: "The area of a rectangle is found by multiplying its length by its width. Always include square units in your answer."
    }
  },
  {
    id: 2,
    subtopic: "Area & Perimeter",
    question: "A circle has a radius of 6. What is its area? (Use π ≈ 3.14)",
    options: [
      { label: "A", value: "18.84" },
      { label: "B", value: "37.68" },
      { label: "C", value: "113.04" },
      { label: "D", value: "226.08" }
    ],
    correctAnswer: "C",
    solution: {
      steps: [
        "Area of a circle = πr²",
        "Substitute r = 6: A = π × 6²",
        "A = π × 36",
        "A ≈ 3.14 × 36 = 113.04"
      ],
      explanation: "The area formula for a circle is A = πr². Square the radius first, then multiply by π."
    }
  },
  {
    id: 3,
    subtopic: "Volume",
    question: "A rectangular prism has length 5, width 4, and height 3. What is its volume?",
    options: [
      { label: "A", value: "47" },
      { label: "B", value: "60" },
      { label: "C", value: "72" },
      { label: "D", value: "94" }
    ],
    correctAnswer: "B",
    solution: {
      steps: [
        "Volume of a rectangular prism = length × width × height",
        "V = 5 × 4 × 3",
        "V = 60"
      ],
      explanation: "Volume of a rectangular prism (box) = l × w × h. Multiply all three dimensions together."
    }
  },
  {
    id: 4,
    subtopic: "Volume",
    question: "A cylinder has a radius of 3 and a height of 10. What is its volume? (Use π ≈ 3.14)",
    options: [
      { label: "A", value: "94.2" },
      { label: "B", value: "188.4" },
      { label: "C", value: "282.6" },
      { label: "D", value: "376.8" }
    ],
    correctAnswer: "C",
    solution: {
      steps: [
        "Volume of a cylinder = πr²h",
        "Substitute r = 3, h = 10: V = π × 3² × 10",
        "V = π × 9 × 10 = 90π",
        "V ≈ 3.14 × 90 = 282.6"
      ],
      explanation: "The volume of a cylinder is the area of its circular base (πr²) multiplied by its height."
    }
  },
  {
    id: 5,
    subtopic: "Pythagorean Theorem",
    question: "A right triangle has legs of length 8 and 15. What is the length of the hypotenuse?",
    options: [
      { label: "A", value: "13" },
      { label: "B", value: "17" },
      { label: "C", value: "19" },
      { label: "D", value: "23" }
    ],
    correctAnswer: "B",
    solution: {
      steps: [
        "Use the Pythagorean theorem: a² + b² = c²",
        "Substitute: 8² + 15² = c²",
        "64 + 225 = c²",
        "289 = c²",
        "c = √289 = 17"
      ],
      explanation: "The Pythagorean theorem states a² + b² = c², where c is the hypotenuse. Recognize 8-15-17 as a Pythagorean triple."
    }
  },
  {
    id: 6,
    subtopic: "Pythagorean Theorem",
    question: "A ladder 13 feet long leans against a wall. The base of the ladder is 5 feet from the wall. How high up the wall does the ladder reach?",
    options: [
      { label: "A", value: "8 ft" },
      { label: "B", value: "10 ft" },
      { label: "C", value: "12 ft" },
      { label: "D", value: "14 ft" }
    ],
    correctAnswer: "C",
    solution: {
      steps: [
        "The ladder, wall, and ground form a right triangle",
        "Hypotenuse = 13, one leg = 5, find the other leg",
        "a² + 5² = 13²",
        "a² + 25 = 169",
        "a² = 144",
        "a = 12 ft"
      ],
      explanation: "Recognize the 5-12-13 Pythagorean triple. The ladder is the hypotenuse, the base is one leg, and the height is the other leg."
    }
  },
  {
    id: 7,
    subtopic: "Special Right Triangles",
    question: "In a 45-45-90 triangle, the legs each have length 7. What is the length of the hypotenuse?",
    options: [
      { label: "A", value: "7" },
      { label: "B", value: "7√2" },
      { label: "C", value: "7√3" },
      { label: "D", value: "14" }
    ],
    correctAnswer: "B",
    solution: {
      steps: [
        "In a 45-45-90 triangle, the ratio of sides is 1 : 1 : √2",
        "If each leg = 7, then hypotenuse = 7 × √2",
        "Hypotenuse = 7√2"
      ],
      explanation: "A 45-45-90 triangle has sides in ratio 1:1:√2. Multiply the leg length by √2 to get the hypotenuse."
    }
  },
  {
    id: 8,
    subtopic: "Special Right Triangles",
    question: "In a 30-60-90 triangle, the shorter leg has length 5. What is the length of the longer leg?",
    options: [
      { label: "A", value: "5" },
      { label: "B", value: "5√2" },
      { label: "C", value: "5√3" },
      { label: "D", value: "10" }
    ],
    correctAnswer: "C",
    solution: {
      steps: [
        "In a 30-60-90 triangle, the ratio of sides is 1 : √3 : 2",
        "Shorter leg (opposite 30°) = 5",
        "Longer leg (opposite 60°) = 5 × √3 = 5√3"
      ],
      explanation: "A 30-60-90 triangle has sides in ratio 1:√3:2. The longer leg is always √3 times the shorter leg."
    }
  },
  {
    id: 9,
    subtopic: "Trigonometry",
    question: "In a right triangle, the angle θ = 30°, and the hypotenuse = 20. What is the length of the side opposite to θ?",
    options: [
      { label: "A", value: "8" },
      { label: "B", value: "10" },
      { label: "C", value: "10√3" },
      { label: "D", value: "20√3" }
    ],
    correctAnswer: "B",
    solution: {
      steps: [
        "Use SOH: sin(θ) = opposite / hypotenuse",
        "sin(30°) = opposite / 20",
        "0.5 = opposite / 20",
        "opposite = 20 × 0.5 = 10"
      ],
      explanation: "SOH: sin = opposite/hypotenuse. sin(30°) = 1/2, so the opposite side = hypotenuse × sin(30°) = 20 × 0.5 = 10."
    }
  },
  {
    id: 10,
    subtopic: "Trigonometry",
    question: "In a right triangle, the adjacent side = 12 and the hypotenuse = 13. What is cos(θ)?",
    options: [
      { label: "A", value: "5/13" },
      { label: "B", value: "12/13" },
      { label: "C", value: "5/12" },
      { label: "D", value: "13/12" }
    ],
    correctAnswer: "B",
    solution: {
      steps: [
        "Use CAH: cos(θ) = adjacent / hypotenuse",
        "cos(θ) = 12 / 13"
      ],
      explanation: "CAH: cosine = adjacent/hypotenuse. The adjacent side is 12 and the hypotenuse is 13, so cos(θ) = 12/13."
    }
  },
  {
    id: 11,
    subtopic: "Trigonometry",
    question: "A ramp rises 6 feet over a horizontal distance of 8 feet. What is the tangent of the angle the ramp makes with the ground?",
    options: [
      { label: "A", value: "3/5" },
      { label: "B", value: "4/5" },
      { label: "C", value: "3/4" },
      { label: "D", value: "4/3" }
    ],
    correctAnswer: "C",
    solution: {
      steps: [
        "Use TOA: tan(θ) = opposite / adjacent",
        "The rise (6 ft) is opposite the angle",
        "The run (8 ft) is adjacent to the angle",
        "tan(θ) = 6/8 = 3/4"
      ],
      explanation: "TOA: tangent = opposite/adjacent. The vertical rise is opposite the angle, and the horizontal run is adjacent."
    }
  },
  {
    id: 12,
    subtopic: "Coordinate Geometry",
    question: "What is the distance between points (1, 2) and (4, 6)?",
    options: [
      { label: "A", value: "3" },
      { label: "B", value: "4" },
      { label: "C", value: "5" },
      { label: "D", value: "7" }
    ],
    correctAnswer: "C",
    solution: {
      steps: [
        "Use the distance formula: d = √((x₂ - x₁)² + (y₂ - y₁)²)",
        "d = √((4 - 1)² + (6 - 2)²)",
        "d = √(3² + 4²)",
        "d = √(9 + 16) = √25 = 5"
      ],
      explanation: "The distance formula is derived from the Pythagorean theorem. Recognize the 3-4-5 right triangle here."
    }
  },
  {
    id: 13,
    subtopic: "Coordinate Geometry",
    question: "What is the midpoint of the segment connecting (-2, 4) and (8, -6)?",
    options: [
      { label: "A", value: "(3, -1)" },
      { label: "B", value: "(3, 1)" },
      { label: "C", value: "(5, -1)" },
      { label: "D", value: "(6, -2)" }
    ],
    correctAnswer: "A",
    solution: {
      steps: [
        "Use the midpoint formula: M = ((x₁ + x₂)/2, (y₁ + y₂)/2)",
        "M = ((-2 + 8)/2, (4 + (-6))/2)",
        "M = (6/2, -2/2)",
        "M = (3, -1)"
      ],
      explanation: "The midpoint is the average of the x-coordinates and the average of the y-coordinates."
    }
  },
  {
    id: 14,
    subtopic: "Coordinate Geometry",
    question: "A circle has center (3, -2) and radius 5. Which equation represents this circle?",
    options: [
      { label: "A", value: "(x - 3)² + (y + 2)² = 5" },
      { label: "B", value: "(x + 3)² + (y - 2)² = 25" },
      { label: "C", value: "(x - 3)² + (y + 2)² = 25" },
      { label: "D", value: "(x - 3)² + (y - 2)² = 25" }
    ],
    correctAnswer: "C",
    solution: {
      steps: [
        "Standard form of a circle: (x - h)² + (y - k)² = r²",
        "Center (h, k) = (3, -2), radius r = 5",
        "Substitute: (x - 3)² + (y - (-2))² = 5²",
        "Simplify: (x - 3)² + (y + 2)² = 25"
      ],
      explanation: "The standard circle equation is (x - h)² + (y - k)² = r². Note: (y - (-2)) becomes (y + 2), and r² = 25."
    }
  },
  {
    id: 15,
    subtopic: "Lines & Angles",
    question: "Two parallel lines are cut by a transversal. One angle measures 65°. What is the measure of its co-interior (same-side interior) angle?",
    options: [
      { label: "A", value: "25°" },
      { label: "B", value: "65°" },
      { label: "C", value: "115°" },
      { label: "D", value: "125°" }
    ],
    correctAnswer: "C",
    solution: {
      steps: [
        "Co-interior angles (same-side interior) are supplementary when lines are parallel",
        "Supplementary angles add up to 180°",
        "Missing angle = 180° - 65° = 115°"
      ],
      explanation: "When parallel lines are cut by a transversal, co-interior (consecutive interior) angles are supplementary — they add to 180°."
    }
  },
  {
    id: 16,
    subtopic: "Lines & Angles",
    question: "The interior angles of a triangle are in the ratio 2:3:4. What is the measure of the largest angle?",
    options: [
      { label: "A", value: "60°" },
      { label: "B", value: "70°" },
      { label: "C", value: "80°" },
      { label: "D", value: "90°" }
    ],
    correctAnswer: "C",
    solution: {
      steps: [
        "The sum of interior angles of a triangle = 180°",
        "Let the angles be 2x, 3x, and 4x",
        "2x + 3x + 4x = 180°",
        "9x = 180°",
        "x = 20°",
        "Largest angle = 4x = 4 × 20° = 80°"
      ],
      explanation: "Set up an equation using the ratio. The sum of all angles in a triangle is always 180°."
    }
  },
  {
    id: 17,
    subtopic: "Area & Perimeter",
    question: "A trapezoid has parallel bases of 8 and 14, and a height of 5. What is its area?",
    options: [
      { label: "A", value: "45" },
      { label: "B", value: "55" },
      { label: "C", value: "70" },
      { label: "D", value: "110" }
    ],
    correctAnswer: "B",
    solution: {
      steps: [
        "Area of a trapezoid = ½ × (b₁ + b₂) × h",
        "Substitute: A = ½ × (8 + 14) × 5",
        "A = ½ × 22 × 5",
        "A = ½ × 110 = 55"
      ],
      explanation: "The trapezoid area formula averages the two parallel bases and multiplies by the height: A = ½(b₁ + b₂)h."
    }
  },
  {
    id: 18,
    subtopic: "Trigonometry",
    question: "If sin(θ) = cos(θ), which of the following must be true?",
    options: [
      { label: "A", value: "θ = 30°" },
      { label: "B", value: "θ = 45°" },
      { label: "C", value: "θ = 60°" },
      { label: "D", value: "θ = 90°" }
    ],
    correctAnswer: "B",
    solution: {
      steps: [
        "sin(θ) = cos(θ) means the opposite and adjacent sides are equal",
        "This occurs in a 45-45-90 triangle",
        "sin(45°) = cos(45°) = √2/2",
        "Therefore θ = 45°"
      ],
      explanation: "sin(θ) = cos(θ) only when θ = 45°. This is because sin(θ) = cos(90° - θ), so θ = 90° - θ, giving θ = 45°."
    }
  },
  {
    id: 19,
    subtopic: "Volume",
    question: "A cone has a radius of 4 and a height of 9. What is its volume? (Use π ≈ 3.14)",
    options: [
      { label: "A", value: "75.36" },
      { label: "B", value: "150.72" },
      { label: "C", value: "452.16" },
      { label: "D", value: "904.32" }
    ],
    correctAnswer: "B",
    solution: {
      steps: [
        "Volume of a cone = (1/3)πr²h",
        "Substitute r = 4, h = 9: V = (1/3) × π × 4² × 9",
        "V = (1/3) × π × 16 × 9",
        "V = (1/3) × 144π",
        "V = 48π ≈ 48 × 3.14 = 150.72"
      ],
      explanation: "A cone's volume is exactly one-third of the cylinder with the same base and height: V = (1/3)πr²h."
    }
  },
  {
    id: 20,
    subtopic: "Coordinate Geometry",
    question: "The equation x² + y² - 6x + 4y - 12 = 0 represents a circle. What is the radius of this circle?",
    options: [
      { label: "A", value: "4" },
      { label: "B", value: "5" },
      { label: "C", value: "6" },
      { label: "D", value: "7" }
    ],
    correctAnswer: "B",
    solution: {
      steps: [
        "Complete the square for x: x² - 6x → (x - 3)² - 9",
        "Complete the square for y: y² + 4y → (y + 2)² - 4",
        "Rewrite: (x - 3)² - 9 + (y + 2)² - 4 - 12 = 0",
        "(x - 3)² + (y + 2)² = 25",
        "r² = 25, so r = 5"
      ],
      explanation: "Complete the square for both x and y to convert to standard form (x-h)² + (y-k)² = r². Then r = √(r²)."
    }
  }
];
